import React from 'react'
import ReactDOM from 'react-dom'

import App from './ApplicationProvider'

ReactDOM.render(<App />, document.getElementById('root'))
